// Route `api` cho thực thể `blDraft` (G-DT): JSON của `/v1/bl` (TblShippingInstruction, SQL 013, không tiền) → dòng "Draft chờ khách".
// Worker chưa có cột phản hồi khách / LOI / hạn SI nên các trường đó để mặc định (chưa gửi). Hub khai vào `API_ROUTES`.
import type { ApiRoute } from '@hana/data';
import type { BillType, BlDraft } from './types';

type Row = Record<string, unknown>;
const str = (v: unknown): string => (typeof v === 'string' ? v.trim() : typeof v === 'number' ? String(v) : '');

const BILLS: Record<string, BillType> = { original: 'Original', surrender: 'Surrender', seaway: 'Seaway', telex: 'Telex' };

/** `TYPE_x0020_BILL` ("Seaway Bill", "Telex release"…) → loại bill của màn; không khớp thì Original. */
export function billTypeOf(v: unknown): BillType {
  const s = str(v).toLowerCase();
  for (const [k, t] of Object.entries(BILLS)) if (s.includes(k)) return t;
  return 'Original';
}

export function blDraftFromApi(r: Row): BlDraft {
  return {
    id: str(r.Id) || str(r.HBL) || str(r.MBL),
    job: str(r.JobID),
    hbl: str(r.HBL) || str(r.MBL),
    cus: str(r.ShortName),
    cne: '',
    car: str(r.CarrierCode) || str(r.Carrier),
    type: billTypeOf(r.TYPE_x0020_BILL),
    src: 'SI',
    loi: 'na',
    ver: 0,
    resp: 'none',
    sent: '—',
    due: '—',
  };
}

const items = (json: unknown): Row[] => {
  const list = (json as { items?: unknown } | null)?.items;
  return Array.isArray(list) ? (list as Row[]) : [];
};

/** Worker phân trang theo `page` + `limit`; chỉ lấy bill còn Draft. */
export const blDraftApiRoute: ApiRoute<BlDraft> = {
  path: '/api/v1/bl',
  query: (q) => {
    const limit = q.limit && q.limit > 0 ? q.limit : 50;
    return { no: q.q?.trim(), status: 'Draft', limit, page: Math.floor((q.offset ?? 0) / limit) + 1 };
  },
  parse: (json) => ({ items: items(json).map(blDraftFromApi), hasMore: (json as { hasMore?: boolean } | null)?.hasMore === true }),
  getPath: (id) => `/api/v1/bl?no=${encodeURIComponent(id)}&limit=1`,
  parseOne: (json) => {
    const r = items(json)[0];
    return r ? blDraftFromApi(r) : null;
  },
};
